import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ClienteSessao } from './data/session.js';
import { Gate } from './app/Gate.js';
import { baseDaApi } from './ui/useAuth.js';
import './ui/theme.css';
import './ui/components.css';

const raiz = document.getElementById('root');
if (!raiz) throw new Error('#root nao existe no index.html');

// Criado FORA do componente: `useAuth` tem o cliente na lista de dependencias,
// entao um cliente novo a cada render refaria a consulta de sessao em laco.
const cliente = new ClienteSessao({ baseUrl: baseDaApi(import.meta.env) });

createRoot(raiz).render(
  <StrictMode>
    <Gate cliente={cliente} baseDaApi={baseDaApi(import.meta.env)} />
  </StrictMode>,
);
